import { Typography } from "@mui/material";
import { useContactCenterTheme } from "../../../../virtual-receptionist/theming/ContactCenterThemeContext";

export const MessageText = ({ message }) => {
  const { theme } = useContactCenterTheme();

  const codeBackground = theme.mode === "dark" ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.07)";

  return (
    <Typography
      variant="body2"
      sx={{
        color: "inherit",
        whiteSpace: "pre-wrap",
        wordBreak: "break-word",
        fontSize: "0.95rem",
        lineHeight: 1.6,
        letterSpacing: 0.1,
        fontWeight: 400,
        transition: "color 0.2s ease",
        "& a": {
          color: theme.link.color,
          textDecoration: "none",
          fontWeight: 500,
          "&:hover": { textDecoration: "underline" },
        },
        "& strong": {
          fontWeight: 600,
          color: "inherit",
        },
        "& code": {
          fontFamily: "monospace",
          backgroundColor: codeBackground,
          padding: "2px 4px",
          borderRadius: "4px",
          fontSize: "0.85rem",
        },
      }}
    >
      {message.content?.text}
    </Typography>
  );
};
